module.exports = __webpack_public_path__ + "static/img/sulfuric-acid_256.8cf02cf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sulfuric-acid_256.png
// module id = ZLFJ
// module chunks = 0